import Link from "next/link";
import { ArrowUpRight } from "lucide-react";

/**
 * Plain crawlable links from an app page to the blog posts that answer its
 * buyers' questions.
 *
 * GSC (Sept 2026): /loyalty and /product-options are indexed and rank on page
 * one for their own names, while the posts targeting the commercial queries
 * ("shopify variant limit", "shopify pos loyalty program") sit at 40-80 — and
 * these pages linked to none of them, only to /blogs/archive. This passes that
 * authority on and tells crawlers which posts matter most.
 *
 * @param {Object} props
 * @param {string} props.title
 * @param {Array<{slug: string, title: string, description: string}>} props.guides
 */
export const AppGuidesSection = ({ title = "Guides", guides = [] }) => {
  if (guides.length === 0) return null;

  return (
    <section className="py-16 relative z-10 bg-[#212121]">
      <div className="mx-auto px-6 md:px-16 lg:px-32 relative z-10 max-w-[1440px]">
        <h2
          className="text-3xl md:text-[40px] font-normal text-white tracking-[-0.24px] text-center mb-12"
          style={{ lineHeight: 1.2 }}
        >
          {title}
        </h2>

        <ul className="grid gap-5 md:grid-cols-2">
          {guides.map((guide) => (
            <li key={guide.slug}>
              <Link
                href={`/blogs/${guide.slug}`}
                className="group flex h-full flex-col rounded-2xl bg-white/5 px-6 py-5 transition-colors hover:bg-white/10"
              >
                <span className="flex items-start justify-between gap-4">
                  <h3 className="text-xl font-medium text-white tracking-[-0.2px]">
                    {guide.title}
                  </h3>
                  <ArrowUpRight
                    aria-hidden="true"
                    className="w-5 h-5 mt-1 shrink-0 text-[#c4c4c4] transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                  />
                </span>
                <p className="mt-3 text-base text-[#c4c4c4] tracking-[-0.032px]">
                  {guide.description}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};
